import api from './api';
import type { MemberDataSource, SourceGrant } from '../types';

/**
 * Per-source data access (Workspaces Layer 3 grants). Managing access is
 * workspace-admin only; the backend gates every call on GRANT_SOURCE_ACCESS and
 * resolves the workspace from the request context.
 */
export const accessApi = {
  /** Every connected source in the workspace + whether this member can query it. */
  getMemberDataAccess: async (userId: string): Promise<{ sources: MemberDataSource[] }> => {
    const { data } = await api.get(`/api/org/users/${userId}/data-access`);
    return data;
  },

  /** Grant a member access to a source. Access is binary today (role defaults to 'analyst'). */
  grantSource: async (
    sourceId: string,
    userId: string,
    role: 'viewer' | 'analyst' = 'analyst',
  ): Promise<void> => {
    await api.post(`/api/sources/${sourceId}/grants`, { userId, role });
  },

  revokeSource: async (sourceId: string, userId: string): Promise<void> => {
    await api.delete(`/api/sources/${sourceId}/grants/${userId}`);
  },

  /** Who currently has access to a source ("who has access" view). */
  getSourceGrants: async (sourceId: string): Promise<SourceGrant[]> => {
    const { data } = await api.get(`/api/sources/${sourceId}/grants`);
    return data.data as SourceGrant[];
  },
};
